export function insertBffAfterBaseUrl(url: string): string {
    try {
        const urlObj = new URL(url)
        const pathname = urlObj.pathname

        urlObj.pathname = `/bff${pathname}`

        return urlObj.toString()
    } catch {
        const parts = url.split('/')
        const protocol = parts[0] // http: or https:
        const domain = parts[2] // localhost:3000 or api.example.com
        const path = parts.slice(3).join('/') // clients or users/123

        return `${protocol}//${domain}/bff/${path}`
    }
}
